import React, { useState } from "react";
import styled from "styled-components/macro";
import uipathLogoImage from "./../../../assets/images/uipath-logo.svg";
import { ButtonApolloPrimary } from "../../Button/Button";
import AddProductModal from "../AddProductSection/AddProductModal/AddProductModal";
import { ALL_PRODUCT_OPTIONS } from "../../../constants/calculatorConstants";
import { Icon } from "@material-ui/core";
import { ButtonApolloSecondary } from "../../Button/Button";
import { jsonToQueryParamData } from "../../../utils/sharableCalculatorUtils";
import { copyTextToClipboard } from "../../../utils/inputUtils";
import { exportCalculatorToExcel } from "../../../utils/excelExportUtils";
import { mdiLinkVariant, mdiMicrosoftExcel, mdiOrderBoolAscendingVariant, mdiRestart } from '@mdi/js';
import MdiIcon from '@mdi/react';

const ButtonContainer = styled.div`
  display: flex;
  place-items: center;
  font-size: 14px;
  min-height: 40px;
`;

const AllAddedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  color: var(--color-success-text);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;

const CheckIcon = styled(Icon)`
  color: var(--color-success-text);
`;

const HeadingContainer = styled.h1`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  padding-bottom: 0;
  gap: 10px;
`;

const H1 = styled.h1`
  color: var(--color-foreground);
  font-size: 1.4rem;
  display: flex;
  margin: 0;
  padding: 0;
  align-items: center;
  flex: 1;

  img {
    margin-right: 6px;
    height: 32px;
    width: auto;
    margin-top: -12px;
  }
`;

const ResetLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`;

let copyTimeout: any = null;
const Heading = ({
  formData,
  selectedProducts,
  onSelectedProductsChange,
  explicitKeys,
}: {
  formData: CalculatorFormDataType;
  selectedProducts: ProductOptionInterface[];
  onSelectedProductsChange: (data: ProductOptionInterface[], explicitKeys: string[]) => void;
  explicitKeys: string[];
}) => {
  const [isAddingProduct, setIsAddingProduct] = useState<boolean>(false);
  const [textWasCopied, setTextWasCopied] = useState(false);

  const handleCopyButtonClick = () => {
    clearTimeout(copyTimeout);
    copyTextToClipboard(
      `${window.location.href.split("?")[0]}?${jsonToQueryParamData(formData)}`
    );
    setTextWasCopied(true);
    copyTimeout = setTimeout(() => {
      setTextWasCopied(false);
    }, 2000);
  };

  const handleExportExcelClick = () => {
    exportCalculatorToExcel(formData);
  };

  const allProductsSelected = selectedProducts.length === ALL_PRODUCT_OPTIONS.length;

  return (
    <HeadingContainer>
      <H1>
        <ResetLink href={window.location.pathname} title="Reset to Defaults">
          <img src={uipathLogoImage} alt="" /> Automation Suite Install Sizing
          Calculator
        </ResetLink>
      </H1>

      <ButtonContainer>
        <ButtonApolloSecondary onClick={() => { window.location.href = window.location.pathname; }} startIcon={<MdiIcon path={mdiRestart} size={1} />}>
          Reset to Defaults
        </ButtonApolloSecondary>
      </ButtonContainer>
      <ButtonContainer>
        <ButtonApolloSecondary onClick={handleCopyButtonClick} startIcon={<MdiIcon path={mdiLinkVariant} size={1} />}>
          {textWasCopied ? "Copied to Clipboard" : "Copy Shareable URL"}
        </ButtonApolloSecondary>
      </ButtonContainer>
      <ButtonContainer>
        <ButtonApolloSecondary onClick={handleExportExcelClick} startIcon={<MdiIcon path={mdiMicrosoftExcel} size={1} />}>
          Export to Excel
        </ButtonApolloSecondary>
      </ButtonContainer>
      <ButtonContainer>
        <ButtonApolloPrimary onClick={() => setIsAddingProduct(true)} startIcon={<MdiIcon path={mdiOrderBoolAscendingVariant} size={1} />}>
          Change Product Selection
        </ButtonApolloPrimary>
        {allProductsSelected && (
          <AllAddedBadge title="All available products are currently selected">
            <CheckIcon fontSize="small">check</CheckIcon>
            All Products Added
          </AllAddedBadge>
        )}
        {isAddingProduct && (
          <AddProductModal
            onClose={() => setIsAddingProduct(false)}
            selectedProducts={selectedProducts}
            onSelectedProductsChange={onSelectedProductsChange}
            highLevelParameters={formData.highLevelParameters}
            parentExplicitKeys={explicitKeys}
          />
        )}
      </ButtonContainer>
    </HeadingContainer>
  );
};

export default Heading;
